// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__1OFho","backButtonIcon":"BackButton_backButtonIcon__v-qbh"};